import { NgModule, Injectable, ErrorHandler, NgZone, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


@Injectable()
export class KaioteeErrorhandler implements ErrorHandler {


  constructor(private zone: NgZone, private inj: Injector) {

  }

  handleError(error) {

    let router = this.inj.get(Router);

    if (error.message == "BackendNotAvailable") {
      router.navigate(['unavailable']);
    }

    if (error.message == "Unauthorized") {
      console.log("Key invalid need to login")
      router.navigate(['login']);
    }

    if (error.message == "Uninitialized") {
      console.log("Uninitialized need to login")
      router.navigate(['login']);
    }



  }
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: KaioteeErrorhandler },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
